import $ from "jquery";
import Highcharts from "highcharts/highstock"; // Import Highstock


if($('#gold-gb-graph').length)
{
    $.getJSON("/wp-content/themes/gold-bullion/data/gold-price-gb.csv", (data) => {
        Highcharts.stockChart("gold-gb-graph", {
          chart: {
              events: {
                load: function() {
                var chart = this;
                  Highcharts.each(chart.rangeSelector.buttons, function (button, index) {
                    button.element.onclick = function () {
                       
                        chart.rangeSelector.clickButton(index, true);
                        if (window.innerWidth <= 992) {
                        Highcharts.each(chart.rangeSelector.buttons, function (button, i) {
                          if (!button.text.textStr.endsWith(' ▾')) {
                            button.text.attr({
                              text: '&nbsp;' + button.text.textStr + ' ▾',
                            });
                          }
                          if (i === index) {
                            button.element.setAttribute('visibility', 'visible');
                          } else {
                            button.element.setAttribute('visibility', 'hidden');
                          }
                        });
                      }
                    };
                });

                  var firstSelected = this.series[0].processedYData[1];
                  var endSelected = this.series[0].processedYData[this.series[0].processedYData.length - 1];


                 document.getElementById("initialPrice").innerText = '£'+firstSelected.toFixed(2);
                 document.getElementById("finalPrice").innerText = '£'+endSelected.toFixed(2);

                 var difference = endSelected - firstSelected;

                 if(difference >= 0){
                     
                      document.getElementById("changeInPrice").innerText = '£'+difference.toFixed(2);

                      var percentageDifference = (difference/firstSelected) * 100;
                      document.getElementById("percentageDifference").innerText = '+' + percentageDifference.toFixed(2) + '%';
                 }
                 else{
                  document.getElementById("changeInPrice").innerText = '£'+difference.toFixed(2);

                  var percentageDifference = (difference/firstSelected) * 100;
                  document.getElementById("percentageDifference").innerText = percentageDifference.toFixed(2) + '%';
                 }

                 var chartWidth = this.plotWidth;
                 var chartHeight = this.plotHeight;
                 var imageWidth = 200; 
                 var imageHeight = 90; 

                 if (window.innerWidth <= 992) {
                  var imageWidth = 150; 
                  var imageHeight = 68; 
                 }
                 var imageX = (chartWidth - imageWidth) / 2;
                 var imageY = (chartHeight - imageHeight) / 2;
       
                 this.renderer.image(
                   '/wp-content/themes/gold-bullion/img/gold-bullion-logo.svg',
                   imageX,
                 imageY,
                 imageWidth,
                 imageHeight
                 ).add();


                },
                redraw: function() {
                  var firstSelected = this.series[0].processedYData[1];
                  var endSelected = this.series[0].processedYData[this.series[0].processedYData.length - 1];

                  document.getElementById("initialPrice").innerText = '£'+firstSelected.toFixed(2);
                  document.getElementById("finalPrice").innerText = '£'+endSelected.toFixed(2);
 
                  var difference = endSelected - firstSelected;
 
                  if(difference >= 0){
                      
                       document.getElementById("changeInPrice").innerText = '£'+difference.toFixed(2);
 
                       var percentageDifference = (difference/firstSelected) * 100;
                       document.getElementById("percentageDifference").innerText = '+' + percentageDifference.toFixed(2) + '%';
                  }
                  else{
                   document.getElementById("changeInPrice").innerText = '£'+difference.toFixed(2);
 
                   var percentageDifference = (difference/firstSelected) * 100;
                   document.getElementById("percentageDifference").innerText = percentageDifference.toFixed(2) + '%';
                  }
                }
              }
            },
          rangeSelector: {
            buttons: [
              {
                type: "day",
                count: 7,
                text: "1w",
                title: "View 1 week",
              },
              {
                type: "month",
                count: 1,
                text: "1m",
                title: "View 1 month",
              },
              {
                type: "month",
                count: 3,
                text: "3m",
                title: "View 3 months",
              },
              {
                type: "month",
                count: 6,
                text: "6m",
                title: "View 6 months",
              },
              {
                type: "ytd",
                text: "YTD",
                title: "View year to date",
              },
              {
                type: "year",
                count: 1,
                text: "1y",
                title: "View 1 year",
              },
              {
                type: "year",
                count: 3,
                text: "3y",
                title: "View 3 years",
              },
              {
                type: "year",
                count: 5,
                text: "5y",
                title: "View 5 years",
              },
              {
                type: "year",
                count: 10,
                text: "10y",
                title: "View 10 years",
              },
              {
                type: "year",
                count: 25,
                text: "25y",
                title: "View 25 years",
              },
              {
                type: "all",
                text: "All",
                title: "View all",
              },
            ],
            buttonTheme: {
              // styles for the buttons
              fill: "none",
              stroke: "none",
              "stroke-width": 0,
              r: 8,
              style: {
                color: "#D1B87F",
                fontWeight: "bold",
              },
              states: {
                hover: {},
                select: {
                  fill: "#D1B87F",
                  style: {
                    color: "white",
                  },
                },
                // disabled: { ... }
              },
            },
            inputBoxBorderColor: "none",
            inputBoxWidth: 120,
            inputBoxHeight: 18,
            inputStyle: {
              color: "#D1B87F",
              fontWeight: "bold",
            },
            labelStyle: {
              color: "#fff",
              fontWeight: "bold",
            },
            selected: 6,
          },
      
          title: {
            text: "",
          },
      
          series: [
            {
              name: "Gold Price GBP",
              data: data,
              type: "areaspline",
              threshold: null,
              tooltip: {
                valueDecimals: 2,
              },
              lineColor: "rgba(208, 183, 127, 0.3)",
              color: "rgba(208, 183, 127, 0.5)",
            },
          ],
          navigator: {
            maskFill: "rgba(208, 183, 127, 0.3)",
            series: {
              type: "areaspline",
              color: "#F4F6F7",
              fillOpacity: 0,
              dataGrouping: {
                smoothed: false,
              },
              lineWidth: 1,
              lineColor: "rgba(208, 183, 127, 0.2)",
              fillColor: {
                linearGradient: {
                  x1: 0,
                  y1: 0,
                  x2: 0,
                  y2: 1,
                },
                stops: [
                  [0, "rgba(208, 183, 127, 0.3)"],
                  [1, "rgba(208, 183, 127, 0.3)"],
                ],
              },
              marker: {
                enabled: false,
              },
              shadow: false,
            },
            yAxis: {
              reversed: false,
            },
          },
      
          credits: { enabled: false },
      
          responsive: {
            rules: [
              {
                condition: {
                  maxWidth: 500,
                },
                chartOptions: {
                  chart: {
                    height: 400,
                  },
                  subtitle: {
                    text: null,
                  },
                  navigator: {
                    enabled: false,
                  },
                },
              },
            ],
          },
        });
      })();
}

if($('#gold-eur-graph').length)
{
    $.getJSON("/wp-content/themes/gold-bullion/data/gold-price-eur.csv", (data) => {
        Highcharts.stockChart("gold-eur-graph", {
          chart: {
              events: {
                load: function() {
                var chart = this;
                  Highcharts.each(chart.rangeSelector.buttons, function (button, index) {
                    button.element.onclick = function () {
                       
                        chart.rangeSelector.clickButton(index, true);
                        if (window.innerWidth <= 992) {
                        Highcharts.each(chart.rangeSelector.buttons, function (button, i) {
                          if (!button.text.textStr.endsWith(' ▾')) {
                            button.text.attr({
                              text: '&nbsp;' + button.text.textStr + ' ▾',
                            });
                          }
                          if (i === index) {
                            button.element.setAttribute('visibility', 'visible');
                          } else {
                            button.element.setAttribute('visibility', 'hidden');
                          }
                        });
                      }
                    };
                });

                  var firstSelected = this.series[0].processedYData[1];
                  var endSelected = this.series[0].processedYData[this.series[0].processedYData.length - 1];


                 document.getElementById("initialPrice").innerText = '€'+firstSelected.toFixed(2);
                 document.getElementById("finalPrice").innerText = '€'+endSelected.toFixed(2);

                 var difference = endSelected - firstSelected;

                 if(difference >= 0){
                     
                      document.getElementById("changeInPrice").innerText = '€'+difference.toFixed(2);

                      var percentageDifference = (difference/firstSelected) * 100;
                      document.getElementById("percentageDifference").innerText = '+' + percentageDifference.toFixed(2) + '%';
                 }
                 else{
                  document.getElementById("changeInPrice").innerText = '€'+difference.toFixed(2);

                  var percentageDifference = (difference/firstSelected) * 100;
                  document.getElementById("percentageDifference").innerText = percentageDifference.toFixed(2) + '%';
                 }

                 var chartWidth = this.plotWidth;
                 var chartHeight = this.plotHeight;
                 var imageWidth = 200; 
                 var imageHeight = 90; 

                 if (window.innerWidth <= 992) {
                  var imageWidth = 150; 
                  var imageHeight = 68; 
                 }
                 var imageX = (chartWidth - imageWidth) / 2;
                 var imageY = (chartHeight - imageHeight) / 2;
       
                 this.renderer.image(
                   '/wp-content/themes/gold-bullion/img/gold-bullion-logo.svg',
                   imageX,
                 imageY,
                 imageWidth,
                 imageHeight
                 ).add();


                },
                redraw: function() {
                  var firstSelected = this.series[0].processedYData[1];
                  var endSelected = this.series[0].processedYData[this.series[0].processedYData.length - 1];

                  document.getElementById("initialPrice").innerText = '€'+firstSelected.toFixed(2);
                  document.getElementById("finalPrice").innerText = '€'+endSelected.toFixed(2);
 
                  var difference = endSelected - firstSelected;
 
                  if(difference >= 0){
                      
                       document.getElementById("changeInPrice").innerText = '€'+difference.toFixed(2);
 
                       var percentageDifference = (difference/firstSelected) * 100;
                       document.getElementById("percentageDifference").innerText = '+' + percentageDifference.toFixed(2) + '%';
                  }
                  else{
                   document.getElementById("changeInPrice").innerText = '€'+difference.toFixed(2);
 
                   var percentageDifference = (difference/firstSelected) * 100;
                   document.getElementById("percentageDifference").innerText = percentageDifference.toFixed(2) + '%';
                  }
                }
              }
            },
          rangeSelector: {
            buttons: [
              {
                type: "day",
                count: 7,
                text: "1w",
                title: "View 1 week",
              },
              {
                type: "month",
                count: 1,
                text: "1m",
                title: "View 1 month",
              },
              {
                type: "month",
                count: 3,
                text: "3m",
                title: "View 3 months",
              },
              {
                type: "month",
                count: 6,
                text: "6m",
                title: "View 6 months",
              },
              {
                type: "ytd",
                text: "YTD",
                title: "View year to date",
              },
              {
                type: "year",
                count: 1,
                text: "1y",
                title: "View 1 year",
              },
              {
                type: "year",
                count: 3,
                text: "3y",
                title: "View 3 years",
              },
              {
                type: "year",
                count: 5,
                text: "5y",
                title: "View 5 years",
              },
              {
                type: "year",
                count: 10,
                text: "10y",
                title: "View 10 years",
              },
              {
                type: "year",
                count: 25,
                text: "25y",
                title: "View 25 years",
              },
              {
                type: "all",
                text: "All",
                title: "View all",
              },
            ],
            buttonTheme: {
              // styles for the buttons
              fill: "none",
              stroke: "none",
              "stroke-width": 0,
              r: 8,
              style: {
                color: "#D1B87F",
                fontWeight: "bold",
              },
              states: {
                hover: {},
                select: {
                  fill: "#D1B87F",
                  style: {
                    color: "white",
                  },
                },
                // disabled: { ... }
              },
            },
            inputBoxBorderColor: "none",
            inputBoxWidth: 120,
            inputBoxHeight: 18,
            inputStyle: {
              color: "#D1B87F",
              fontWeight: "bold",
            },
            labelStyle: {
              color: "#fff",
              fontWeight: "bold",
            },
            selected: 6,
          },
      
          title: {
            text: "",
          },
      
          series: [
            {
              name: "Gold Price EUR",
              data: data,
              type: "areaspline",
              threshold: null,
              tooltip: {
                valueDecimals: 2,
              },
              lineColor: "rgba(208, 183, 127, 0.3)",
              color: "rgba(208, 183, 127, 0.5)",
            },
          ],
          navigator: {
            maskFill: "rgba(208, 183, 127, 0.3)",
            series: {
              type: "areaspline",
              color: "#F4F6F7",
              fillOpacity: 0,
              dataGrouping: {
                smoothed: false,
              },
              lineWidth: 1,
              lineColor: "rgba(208, 183, 127, 0.2)",
              fillColor: {
                linearGradient: {
                  x1: 0,
                  y1: 0,
                  x2: 0,
                  y2: 1,
                },
                stops: [
                  [0, "rgba(208, 183, 127, 0.3)"],
                  [1, "rgba(208, 183, 127, 0.3)"],
                ],
              },
              marker: {
                enabled: false,
              },
              shadow: false,
            },
            yAxis: {
              reversed: false,
            },
          },
      
          credits: { enabled: false },
      
          responsive: {
            rules: [
              {
                condition: {
                  maxWidth: 500,
                },
                chartOptions: {
                  chart: {
                    height: 400,
                  },
                  subtitle: {
                    text: null,
                  },
                  navigator: {
                    enabled: false,
                  },
                },
              },
            ],
          },
        });
      })();
}

if($('#gold-usd-graph').length)
{
    $.getJSON("/wp-content/themes/gold-bullion/data/gold-price-usd.csv", (data) => {
        Highcharts.stockChart("gold-usd-graph", {
          chart: {
              events: {
                load: function() {
                var chart = this;
                  Highcharts.each(chart.rangeSelector.buttons, function (button, index) {
                    button.element.onclick = function () {
                       
                        chart.rangeSelector.clickButton(index, true);
                        if (window.innerWidth <= 992) {
                        Highcharts.each(chart.rangeSelector.buttons, function (button, i) {
                          if (!button.text.textStr.endsWith(' ▾')) {
                            button.text.attr({
                              text: '&nbsp;' + button.text.textStr + ' ▾',
                            });
                          }
                          if (i === index) {
                            button.element.setAttribute('visibility', 'visible');
                          } else {
                            button.element.setAttribute('visibility', 'hidden');
                          }
                        });
                      }
                    };
                });

                  var firstSelected = this.series[0].processedYData[1];
                  var endSelected = this.series[0].processedYData[this.series[0].processedYData.length - 1];


                 document.getElementById("initialPrice").innerText = '$'+firstSelected.toFixed(2);
                 document.getElementById("finalPrice").innerText = '$'+endSelected.toFixed(2);

                 var difference = endSelected - firstSelected;

                 if(difference >= 0){
                     
                      document.getElementById("changeInPrice").innerText = '$'+difference.toFixed(2);

                      var percentageDifference = (difference/firstSelected) * 100;
                      document.getElementById("percentageDifference").innerText = '+' + percentageDifference.toFixed(2) + '%';
                 }
                 else{
                  document.getElementById("changeInPrice").innerText = '$'+difference.toFixed(2);

                  var percentageDifference = (difference/firstSelected) * 100;
                  document.getElementById("percentageDifference").innerText = percentageDifference.toFixed(2) + '%';
                 }

                 var chartWidth = this.plotWidth;
                 var chartHeight = this.plotHeight;
                 var imageWidth = 200; 
                 var imageHeight = 90; 

                 if (window.innerWidth <= 992) {
                  var imageWidth = 150; 
                  var imageHeight = 68; 
                 }
                 var imageX = (chartWidth - imageWidth) / 2;
                 var imageY = (chartHeight - imageHeight) / 2;
       
                 this.renderer.image(
                   '/wp-content/themes/gold-bullion/img/gold-bullion-logo.svg',
                   imageX,
                 imageY,
                 imageWidth,
                 imageHeight
                 ).add();


                },
                redraw: function() {
                  var firstSelected = this.series[0].processedYData[1];
                  var endSelected = this.series[0].processedYData[this.series[0].processedYData.length - 1];

                  document.getElementById("initialPrice").innerText = '$'+firstSelected.toFixed(2);
                  document.getElementById("finalPrice").innerText = '$'+endSelected.toFixed(2);
 
                  var difference = endSelected - firstSelected;
 
                  if(difference >= 0){
                      
                       document.getElementById("changeInPrice").innerText = '$'+difference.toFixed(2);
 
                       var percentageDifference = (difference/firstSelected) * 100;
                       document.getElementById("percentageDifference").innerText = '+' + percentageDifference.toFixed(2) + '%';
                  }
                  else{
                   document.getElementById("changeInPrice").innerText = '$'+difference.toFixed(2);
 
                   var percentageDifference = (difference/firstSelected) * 100;
                   document.getElementById("percentageDifference").innerText = percentageDifference.toFixed(2) + '%';
                  }
                }
              }
            },
          rangeSelector: {
            buttons: [
              {
                type: "day",
                count: 7,
                text: "1w",
                title: "View 1 week",
              },
              {
                type: "month",
                count: 1,
                text: "1m",
                title: "View 1 month",
              },
              {
                type: "month",
                count: 3,
                text: "3m",
                title: "View 3 months",
              },
              {
                type: "month",
                count: 6,
                text: "6m",
                title: "View 6 months",
              },
              {
                type: "ytd",
                text: "YTD",
                title: "View year to date",
              },
              {
                type: "year",
                count: 1,
                text: "1y",
                title: "View 1 year",
              },
              {
                type: "year",
                count: 3,
                text: "3y",
                title: "View 3 years",
              },
              {
                type: "year",
                count: 5,
                text: "5y",
                title: "View 5 years",
              },
              {
                type: "year",
                count: 10,
                text: "10y",
                title: "View 10 years",
              },
              {
                type: "year",
                count: 25,
                text: "25y",
                title: "View 25 years",
              },
              {
                type: "all",
                text: "All",
                title: "View all",
              },
            ],
            buttonTheme: {
              // styles for the buttons
              fill: "none",
              stroke: "none",
              "stroke-width": 0,
              r: 8,
              style: {
                color: "#D1B87F",
                fontWeight: "bold",
              },
              states: {
                hover: {},
                select: {
                  fill: "#D1B87F",
                  style: {
                    color: "white",
                  },
                },
                // disabled: { ... }
              },
            },
            inputBoxBorderColor: "none",
            inputBoxWidth: 120,
            inputBoxHeight: 18,
            inputStyle: {
              color: "#D1B87F",
              fontWeight: "bold",
            },
            labelStyle: {
              color: "#fff",
              fontWeight: "bold",
            },
            selected: 6,
          },
      
          title: {
            text: "",
          },
      
          series: [
            {
              name: "Gold Price USD",
              data: data,
              type: "areaspline",
              threshold: null,
              tooltip: {
                valueDecimals: 2,
              },
              lineColor: "rgba(208, 183, 127, 0.3)",
              color: "rgba(208, 183, 127, 0.5)",
            },
          ],
          navigator: {
            maskFill: "rgba(208, 183, 127, 0.3)",
            series: {
              type: "areaspline",
              color: "#F4F6F7",
              fillOpacity: 0,
              dataGrouping: {
                smoothed: false,
              },
              lineWidth: 1,
              lineColor: "rgba(208, 183, 127, 0.2)",
              fillColor: {
                linearGradient: {
                  x1: 0,
                  y1: 0,
                  x2: 0,
                  y2: 1,
                },
                stops: [
                  [0, "rgba(208, 183, 127, 0.3)"],
                  [1, "rgba(208, 183, 127, 0.3)"],
                ],
              },
              marker: {
                enabled: false,
              },
              shadow: false,
            },
            yAxis: {
              reversed: false,
            },
          },
      
          credits: { enabled: false },
      
          responsive: {
            rules: [
              {
                condition: {
                  maxWidth: 500,
                },
                chartOptions: {
                  chart: {
                    height: 400,
                  },
                  subtitle: {
                    text: null,
                  },
                  navigator: {
                    enabled: false,
                  },
                },
              },
            ],
          },
        });
      })();
}

if($('#silver-gb-graph').length)
{
    $.getJSON("/wp-content/themes/gold-bullion/data/silver-price-gb.csv", (data) => {
        Highcharts.stockChart("silver-gb-graph", {
          chart: {
              events: {
                load: function() {
                var chart = this;
                  Highcharts.each(chart.rangeSelector.buttons, function (button, index) {
                    button.element.onclick = function () {
                       
                        chart.rangeSelector.clickButton(index, true);
                        if (window.innerWidth <= 992) {
                        Highcharts.each(chart.rangeSelector.buttons, function (button, i) {
                          if (!button.text.textStr.endsWith(' ▾')) {
                            button.text.attr({
                              text: '&nbsp;' + button.text.textStr + ' ▾',
                            });
                          }
                          if (i === index) {
                            button.element.setAttribute('visibility', 'visible');
                          } else {
                            button.element.setAttribute('visibility', 'hidden');
                          }
                        });
                      }
                    };
                });

                  var firstSelected = this.series[0].processedYData[1];
                  var endSelected = this.series[0].processedYData[this.series[0].processedYData.length - 1];


                 document.getElementById("initialPrice").innerText = '£'+firstSelected.toFixed(2);
                 document.getElementById("finalPrice").innerText = '£'+endSelected.toFixed(2);

                 var difference = endSelected - firstSelected;

                 if(difference >= 0){
                     
                      document.getElementById("changeInPrice").innerText = '£'+difference.toFixed(2);

                      var percentageDifference = (difference/firstSelected) * 100;
                      document.getElementById("percentageDifference").innerText = '+' + percentageDifference.toFixed(2) + '%';
                 }
                 else{
                  document.getElementById("changeInPrice").innerText = '£'+difference.toFixed(2);

                  var percentageDifference = (difference/firstSelected) * 100;
                  document.getElementById("percentageDifference").innerText = percentageDifference.toFixed(2) + '%';
                 }

                 var chartWidth = this.plotWidth;
                 var chartHeight = this.plotHeight;
                 var imageWidth = 200; 
                 var imageHeight = 90; 

                 if (window.innerWidth <= 992) {
                  var imageWidth = 150; 
                  var imageHeight = 68; 
                 }
                 var imageX = (chartWidth - imageWidth) / 2;
                 var imageY = (chartHeight - imageHeight) / 2;
       
                 this.renderer.image(
                   '/wp-content/themes/gold-bullion/img/gold-bullion-logo-silver.svg',
                   imageX,
                 imageY,
                 imageWidth,
                 imageHeight
                 ).add();


                },
                redraw: function() {
                  var firstSelected = this.series[0].processedYData[1];
                  var endSelected = this.series[0].processedYData[this.series[0].processedYData.length - 1];

                  document.getElementById("initialPrice").innerText = '£'+firstSelected.toFixed(2);
                  document.getElementById("finalPrice").innerText = '£'+endSelected.toFixed(2);
 
                  var difference = endSelected - firstSelected;
 
                  if(difference >= 0){
                      
                       document.getElementById("changeInPrice").innerText = '£'+difference.toFixed(2);
 
                       var percentageDifference = (difference/firstSelected) * 100;
                       document.getElementById("percentageDifference").innerText = '+' + percentageDifference.toFixed(2) + '%';
                  }
                  else{
                   document.getElementById("changeInPrice").innerText = '£'+difference.toFixed(2);
 
                   var percentageDifference = (difference/firstSelected) * 100;
                   document.getElementById("percentageDifference").innerText = percentageDifference.toFixed(2) + '%';
                  }
                }
              }
            },
          rangeSelector: {
            buttons: [
              {
                type: "day",
                count: 7,
                text: "1w",
                title: "View 1 week",
              },
              {
                type: "month",
                count: 1,
                text: "1m",
                title: "View 1 month",
              },
              {
                type: "month",
                count: 3,
                text: "3m",
                title: "View 3 months",
              },
              {
                type: "month",
                count: 6,
                text: "6m",
                title: "View 6 months",
              },
              {
                type: "ytd",
                text: "YTD",
                title: "View year to date",
              },
              {
                type: "year",
                count: 1,
                text: "1y",
                title: "View 1 year",
              },
              {
                type: "year",
                count: 3,
                text: "3y",
                title: "View 3 years",
              },
              {
                type: "year",
                count: 5,
                text: "5y",
                title: "View 5 years",
              },
              {
                type: "year",
                count: 10,
                text: "10y",
                title: "View 10 years",
              },
              {
                type: "year",
                count: 25,
                text: "25y",
                title: "View 25 years",
              },
              {
                type: "all",
                text: "All",
                title: "View all",
              },
            ],
            buttonTheme: {
              // styles for the buttons
              fill: "none",
              stroke: "none",
              "stroke-width": 0,
              r: 8,
              style: {
                color: "#888888",
                fontWeight: "bold",
              },
              states: {
                hover: {},
                select: {
                  fill: "#888888",
                  style: {
                    color: "white",
                  },
                },
                // disabled: { ... }
              },
            },
            inputBoxBorderColor: "none",
            inputBoxWidth: 120,
            inputBoxHeight: 18,
            inputStyle: {
              color: "#888888",
              fontWeight: "bold",
            },
            labelStyle: {
              color: "#fff",
              fontWeight: "bold",
            },
            selected: 6,
          },
      
          title: {
            text: "",
          },
      
          series: [
            {
              name: "Silver Price GBP",
              data: data,
              type: "areaspline",
              threshold: null,
              tooltip: {
                valueDecimals: 2,
              },
              lineColor: "rgba(136, 136, 136, 0.3)",
              color: "rgba(136, 136, 136, 0.5)",
            },
          ],
          navigator: {
            maskFill: "rgba(136, 136, 136, 0.3)",
            series: {
              type: "areaspline",
              color: "#F4F6F7",
              fillOpacity: 0,
              dataGrouping: {
                smoothed: false,
              },
              lineWidth: 1,
              lineColor: "136, 136, 136, 0.2)",
              fillColor: {
                linearGradient: {
                  x1: 0,
                  y1: 0,
                  x2: 0,
                  y2: 1,
                },
                stops: [
                  [0, "rgba(136, 136, 136, 0.3)"],
                  [1, "rgba(136, 136, 136, 0.3)"],
                ],
              },
              marker: {
                enabled: false,
              },
              shadow: false,
            },
            yAxis: {
              reversed: false,
            },
          },
      
          credits: { enabled: false },
      
          responsive: {
            rules: [
              {
                condition: {
                  maxWidth: 500,
                },
                chartOptions: {
                  chart: {
                    height: 400,
                  },
                  subtitle: {
                    text: null,
                  },
                  navigator: {
                    enabled: false,
                  },
                },
              },
            ],
          },
        });
      })();
}

if($('#silver-eur-graph').length)
{
    $.getJSON("/wp-content/themes/gold-bullion/data/silver-price-eur.csv", (data) => {
        Highcharts.stockChart("silver-eur-graph", {
          chart: {
              events: {
                load: function() {
                var chart = this;
                  Highcharts.each(chart.rangeSelector.buttons, function (button, index) {
                    button.element.onclick = function () {
                       
                        chart.rangeSelector.clickButton(index, true);
                        if (window.innerWidth <= 992) {
                        Highcharts.each(chart.rangeSelector.buttons, function (button, i) {
                          if (!button.text.textStr.endsWith(' ▾')) {
                            button.text.attr({
                              text: '&nbsp;' + button.text.textStr + ' ▾',
                            });
                          }
                          if (i === index) {
                            button.element.setAttribute('visibility', 'visible');
                          } else {
                            button.element.setAttribute('visibility', 'hidden');
                          }
                        });
                      }
                    };
                });

                  var firstSelected = this.series[0].processedYData[1];
                  var endSelected = this.series[0].processedYData[this.series[0].processedYData.length - 1];


                 document.getElementById("initialPrice").innerText = '€'+firstSelected.toFixed(2);
                 document.getElementById("finalPrice").innerText = '€'+endSelected.toFixed(2);

                 var difference = endSelected - firstSelected;

                 if(difference >= 0){
                     
                      document.getElementById("changeInPrice").innerText = '€'+difference.toFixed(2);

                      var percentageDifference = (difference/firstSelected) * 100;
                      document.getElementById("percentageDifference").innerText = '+' + percentageDifference.toFixed(2) + '%';
                 }
                 else{
                  document.getElementById("changeInPrice").innerText = '€'+difference.toFixed(2);

                  var percentageDifference = (difference/firstSelected) * 100;
                  document.getElementById("percentageDifference").innerText = percentageDifference.toFixed(2) + '%';
                 }

                 var chartWidth = this.plotWidth;
                 var chartHeight = this.plotHeight;
                 var imageWidth = 200; 
                 var imageHeight = 90; 

                 if (window.innerWidth <= 992) {
                  var imageWidth = 150; 
                  var imageHeight = 68; 
                 }
                 var imageX = (chartWidth - imageWidth) / 2;
                 var imageY = (chartHeight - imageHeight) / 2;
       
                 this.renderer.image(
                   '/wp-content/themes/gold-bullion/img/gold-bullion-logo-silver.svg',
                   imageX,
                 imageY,
                 imageWidth,
                 imageHeight
                 ).add();


                },
                redraw: function() {
                  var firstSelected = this.series[0].processedYData[1];
                  var endSelected = this.series[0].processedYData[this.series[0].processedYData.length - 1];

                  document.getElementById("initialPrice").innerText = '€'+firstSelected.toFixed(2);
                  document.getElementById("finalPrice").innerText = '€'+endSelected.toFixed(2);
 
                  var difference = endSelected - firstSelected;
 
                  if(difference >= 0){
                      
                       document.getElementById("changeInPrice").innerText = '€'+difference.toFixed(2);
 
                       var percentageDifference = (difference/firstSelected) * 100;
                       document.getElementById("percentageDifference").innerText = '+' + percentageDifference.toFixed(2) + '%';
                  }
                  else{
                   document.getElementById("changeInPrice").innerText = '€'+difference.toFixed(2);
 
                   var percentageDifference = (difference/firstSelected) * 100;
                   document.getElementById("percentageDifference").innerText = percentageDifference.toFixed(2) + '%';
                  }
                }
              }
            },
          rangeSelector: {
            buttons: [
              {
                type: "day",
                count: 7,
                text: "1w",
                title: "View 1 week",
              },
              {
                type: "month",
                count: 1,
                text: "1m",
                title: "View 1 month",
              },
              {
                type: "month",
                count: 3,
                text: "3m",
                title: "View 3 months",
              },
              {
                type: "month",
                count: 6,
                text: "6m",
                title: "View 6 months",
              },
              {
                type: "ytd",
                text: "YTD",
                title: "View year to date",
              },
              {
                type: "year",
                count: 1,
                text: "1y",
                title: "View 1 year",
              },
              {
                type: "year",
                count: 3,
                text: "3y",
                title: "View 3 years",
              },
              {
                type: "year",
                count: 5,
                text: "5y",
                title: "View 5 years",
              },
              {
                type: "year",
                count: 10,
                text: "10y",
                title: "View 10 years",
              },
              {
                type: "year",
                count: 25,
                text: "25y",
                title: "View 25 years",
              },
              {
                type: "all",
                text: "All",
                title: "View all",
              },
            ],
            buttonTheme: {
              // styles for the buttons
              fill: "none",
              stroke: "none",
              "stroke-width": 0,
              r: 8,
              style: {
                color: "#888888",
                fontWeight: "bold",
              },
              states: {
                hover: {},
                select: {
                  fill: "#888888",
                  style: {
                    color: "white",
                  },
                },
                // disabled: { ... }
              },
            },
            inputBoxBorderColor: "none",
            inputBoxWidth: 120,
            inputBoxHeight: 18,
            inputStyle: {
              color: "#888888",
              fontWeight: "bold",
            },
            labelStyle: {
              color: "#fff",
              fontWeight: "bold",
            },
            selected: 6,
          },
      
          title: {
            text: "",
          },
      
          series: [
            {
              name: "Silver Price EUR",
              data: data,
              type: "areaspline",
              threshold: null,
              tooltip: {
                valueDecimals: 2,
              },
              lineColor: "rgba(136, 136, 136, 0.3)",
              color: "rgba(136, 136, 136, 0.5)",
            },
          ],
          navigator: {
            maskFill: "rgba(136, 136, 136, 0.3)",
            series: {
              type: "areaspline",
              color: "#F4F6F7",
              fillOpacity: 0,
              dataGrouping: {
                smoothed: false,
              },
              lineWidth: 1,
              lineColor: "rgba(136, 136, 136, 0.2)",
              fillColor: {
                linearGradient: {
                  x1: 0,
                  y1: 0,
                  x2: 0,
                  y2: 1,
                },
                stops: [
                  [0, "rgba(136, 136, 136, 0.3)"],
                  [1, "rgba(136, 136, 136, 0.3)"],
                ],
              },
              marker: {
                enabled: false,
              },
              shadow: false,
            },
            yAxis: {
              reversed: false,
            },
          },
      
          credits: { enabled: false },
      
          responsive: {
            rules: [
              {
                condition: {
                  maxWidth: 500,
                },
                chartOptions: {
                  chart: {
                    height: 400,
                  },
                  subtitle: {
                    text: null,
                  },
                  navigator: {
                    enabled: false,
                  },
                },
              },
            ],
          },
        });
      })();
}

if($('#silver-usd-graph').length)
{
    $.getJSON("/wp-content/themes/gold-bullion/data/silver-price-usd.csv", (data) => {
        Highcharts.stockChart("silver-usd-graph", {
          chart: {
              events: {
                load: function() {
                  var chart = this;
                  Highcharts.each(chart.rangeSelector.buttons, function (button, index) {
                    button.element.onclick = function () {
                       
                        chart.rangeSelector.clickButton(index, true);
                        if (window.innerWidth <= 992) {
                        Highcharts.each(chart.rangeSelector.buttons, function (button, i) {
                          if (!button.text.textStr.endsWith(' ▾')) {
                            button.text.attr({
                              text: '&nbsp;' + button.text.textStr + ' ▾',
                            });
                          }
                          if (i === index) {
                            button.element.setAttribute('visibility', 'visible');
                          } else {
                            button.element.setAttribute('visibility', 'hidden');
                          }
                        });
                      }
                    };
                });

                  var firstSelected = this.series[0].processedYData[1];
                  var endSelected = this.series[0].processedYData[this.series[0].processedYData.length - 1];


                 document.getElementById("initialPrice").innerText = '$'+firstSelected.toFixed(2);
                 document.getElementById("finalPrice").innerText = '$'+endSelected.toFixed(2);

                 var difference = endSelected - firstSelected;

                 if(difference >= 0){
                     
                      document.getElementById("changeInPrice").innerText = '$'+difference.toFixed(2);

                      var percentageDifference = (difference/firstSelected) * 100;
                      document.getElementById("percentageDifference").innerText = '+' + percentageDifference.toFixed(2) + '%';
                 }
                 else{
                  document.getElementById("changeInPrice").innerText = '$'+difference.toFixed(2);

                  var percentageDifference = (difference/firstSelected) * 100;
                  document.getElementById("percentageDifference").innerText = percentageDifference.toFixed(2) + '%';
                 }

                 var chartWidth = this.plotWidth;
                 var chartHeight = this.plotHeight;
                 var imageWidth = 200; 
                 var imageHeight = 90; 

                 if (window.innerWidth <= 992) {
                  var imageWidth = 150; 
                  var imageHeight = 68; 
                 }

                 var imageX = (chartWidth - imageWidth) / 2;
                 var imageY = (chartHeight - imageHeight) / 2;
       
                 this.renderer.image(
                   '/wp-content/themes/gold-bullion/img/gold-bullion-logo-silver.svg',
                   imageX,
                 imageY,
                 imageWidth,
                 imageHeight
                 ).add();


                },
                redraw: function() {
                  var firstSelected = this.series[0].processedYData[1];
                  var endSelected = this.series[0].processedYData[this.series[0].processedYData.length - 1];

                  document.getElementById("initialPrice").innerText = '$'+firstSelected.toFixed(2);
                  document.getElementById("finalPrice").innerText = '$'+endSelected.toFixed(2);
 
                  var difference = endSelected - firstSelected;
 
                  if(difference >= 0){
                      
                       document.getElementById("changeInPrice").innerText = '$'+difference.toFixed(2);
 
                       var percentageDifference = (difference/firstSelected) * 100;
                       document.getElementById("percentageDifference").innerText = '+' + percentageDifference.toFixed(2) + '%';
                  }
                  else{
                   document.getElementById("changeInPrice").innerText = '$'+difference.toFixed(2);
 
                   var percentageDifference = (difference/firstSelected) * 100;
                   document.getElementById("percentageDifference").innerText = percentageDifference.toFixed(2) + '%';
                  }
                }
              }
            },
          rangeSelector: {
            buttons: [
              {
                type: "day",
                count: 7,
                text: "1w",
                title: "View 1 week",
              },
              {
                type: "month",
                count: 1,
                text: "1m",
                title: "View 1 month",
              },
              {
                type: "month",
                count: 3,
                text: "3m",
                title: "View 3 months",
              },
              {
                type: "month",
                count: 6,
                text: "6m",
                title: "View 6 months",
              },
              {
                type: "ytd",
                text: "YTD",
                title: "View year to date",
              },
              {
                type: "year",
                count: 1,
                text: "1y",
                title: "View 1 year",
              },
              {
                type: "year",
                count: 3,
                text: "3y",
                title: "View 3 years",
              },
              {
                type: "year",
                count: 5,
                text: "5y",
                title: "View 5 years",
              },
              {
                type: "year",
                count: 10,
                text: "10y",
                title: "View 10 years",
              },
              {
                type: "year",
                count: 25,
                text: "25y",
                title: "View 25 years",
              },
              {
                type: "all",
                text: "All",
                title: "View all",
              },
            ],
            buttonTheme: {
              // styles for the buttons
              fill: "none",
              stroke: "none",
              "stroke-width": 0,
              r: 8,
              style: {
                color: "#D1B87F",
                fontWeight: "bold",
              },
              states: {
                hover: {},
                select: {
                  fill: "#888888",
                  style: {
                    color: "white",
                  },
                },
                // disabled: { ... }
              },
            },
            inputBoxBorderColor: "none",
            inputBoxWidth: 120,
            inputBoxHeight: 18,
            inputStyle: {
              color: "#888888",
              fontWeight: "bold",
            },
            labelStyle: {
              color: "#fff",
              fontWeight: "bold",
            },
            selected: 6,
          },
      
          title: {
            text: "",
          },
      
          series: [
            {
              name: "Silver Price USD",
              data: data,
              type: "areaspline",
              threshold: null,
              tooltip: {
                valueDecimals: 2,
              },
              lineColor: "rgba(136, 136, 136, 0.3)",
              color: "rgba(136, 136, 136, 0.5)",
            },
          ],
          navigator: {
            maskFill: "rgba(136, 136, 136, 0.3)",
            series: {
              type: "areaspline",
              color: "#F4F6F7",
              fillOpacity: 0,
              dataGrouping: {
                smoothed: false,
              },
              lineWidth: 1,
              lineColor: "rgba(136, 136, 136, 0.2)",
              fillColor: {
                linearGradient: {
                  x1: 0,
                  y1: 0,
                  x2: 0,
                  y2: 1,
                },
                stops: [
                  [0, "rgba(136, 136, 136, 0.3)"],
                  [1, "rgba(136, 136, 136, 0.3)"],
                ],
              },
              marker: {
                enabled: false,
              },
              shadow: false,
            },
            yAxis: {
              reversed: false,
            },
          },
      
          credits: { enabled: false },
      
          responsive: {
            rules: [
              {
                condition: {
                  maxWidth: 500,
                },
                chartOptions: {
                  chart: {
                    height: 400,
                  },
                  subtitle: {
                    text: null,
                  },
                  navigator: {
                    enabled: false,
                  },
                },
              },
            ],
          },
        });
      })();
}